import { Button, PlusCircleIcon, PlusIcon } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { ReportingMelcoMachineStatisticsModelsGroupListItem } from "melco-shared-logic";
import { useAddRemoveMachineGroups } from "../../../hooks/reporting/useAddRemoveMachineGroup";

export type BulkActionAddMachineGroupsProps = {
  allMachineGroups?: ReportingMelcoMachineStatisticsModelsGroupListItem[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionAddMachineGroups: React.FC<
  BulkActionAddMachineGroupsProps
> = ({ allMachineGroups, selectedRowKeys, setSelectedRowKeys }) => {
  const { t } = useTranslation();
  const { addGroups } = useAddRemoveMachineGroups();
  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          icon={<PlusIcon />}
         // type="primary"
          onClick={() => {
            if (allMachineGroups) {
              const machineGroupsToAdd = allMachineGroups.filter((c: any) => {
                return selectedRowKeys.includes(c.name!);
              });

              addGroups(machineGroupsToAdd);
              setSelectedRowKeys([]);
            }
          }}
        >
          {t("reporting.statistics.filters.machineGroup.add.add_selected")}
        </Button>
      )}
    </>
  );
};
